<div class="auth-wrapper">
    <div class="container-fluid ">
      <div class="row flex-row h-100">
        <div class=" col-md-12 p-0 d-md-block d-lg-block">
          <div class="bg2" style="background-image: url('assets/images/login-back.png')">
            <div class="overlay"></div>
            <app-lang></app-lang>
            <div class="col-xl-6 col-lg-6 col-md-9 my-auto">
              <div class="container-login">
                <div class="wrap-login">
  
                  <!-- <form class="login-form">-->
                  <form #f="ngForm" novalidate (ngSubmit)="changeUserPassword(f)" class="login-form">
                    <a class="logo-centered d-flex align-items-center justify-content-center" [routerLink]="['/']" >
                      <img src="assets/images/logo-login.png" class="" alt="">
                      <div class="logo-text">
                        <p>  {{'form.university-hospital' | translate}}</p>
                        <p> {{'form.saudi-electronic' | translate}}</p>
                        </div>
                        </a>
                    <span class="login-form-title ">
                      {{'Password.changePassword' | translate}}
                    </span>
  
                     <!-- loginfailed message-->
                    <!-- <span class="login-form-failed " *ngIf="">
                      {{'errors.loginfailed' | translate}}
                    </span> -->
  
                  
  
                    <div class=" input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"><i class="ik ik-lock"></i></span>
                      </div>
                      <!-- <input class="form-control" type="password" name="pass" placeholder="Password">-->
                      <input class="form-control" type="password" id="oldPassword"  name="oldPassword" placeholder="   {{'Password.oldPassword' | translate}}"  [(ngModel)]="oldPassword" #Password="ngModel"  required UserPassword>
                      <div  style=" color: #f28d1e; font-size: 12px;display: block; "  class="valid-feedback"  *ngIf=" Password.invalid && (Password.dirty || Password.touched)">
                                 
                        <span *ngIf="Password.errors.required"  >
                          {{'validation.enterValue' | translate}}
                        </span>
                        <span *ngIf="Password.errors.Exist"  >
                          {{'validation.userPassword' | translate}}
                        </span>
                      </div>
                    </div>
                    <div class=" input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="ik ik-lock"></i></span>
                        </div>
                        <!-- <input class="form-control" type="password" name="pass" placeholder="Password">-->
                        <input class="form-control" type="password" id="newPassword"  name="newPassword" placeholder="   {{'Password.newPassword' | translate}}"  [(ngModel)]="changePassword.NewPassword"   #NewPassword="ngModel"  required  pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}" >
                        <div  style=" color: #f28d1e; font-size: 12px;display: block; "  class="valid-feedback"  *ngIf=" NewPassword.invalid && (NewPassword.dirty || NewPassword.touched)">
                                 
                            <span *ngIf="NewPassword.errors.required"  >
                              {{'validation.enterValue' | translate}}
                            </span>
                            <span *ngIf="NewPassword.errors.pattern"  >
                              {{'validation.passwordPattern' | translate}}
                            </span>
                        
                          </div>
                      </div>
                      <div class=" input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="ik ik-lock"></i></span>
                        </div>
                        <!-- <input class="form-control" type="password" name="pass" placeholder="Password">-->
                        <input class="form-control" type="password" id="confirmNewPassword"  name="confirmNewPassword" placeholder="   {{'Password.confirmPassword' | translate}}" required pattern="{{ NewPassword.value }}" [(ngModel)]="confirmPassword" #confirmPass="ngModel">
                        <div  style=" color: #f28d1e; font-size: 12px;display: block; "  class="valid-feedback"  *ngIf=" confirmPass.invalid && (confirmPass.dirty || confirmPass.touched)">
                                 
                            <span *ngIf="confirmPass.errors.required"  >
                              {{'validation.enterValue' | translate}}
                            </span>
                            <span *ngIf="confirmPass.errors.pattern"  >
                              {{'validation.confirmPassword' | translate}}
                            </span>
                          </div>
                      </div>
  
  
  
                   
                    <div class="d-flex justify-content-between">
                      <!-- <button class="login-form-btn">
                                  <i class="ik ik-log-in"></i>
                              Login
                            </button>-->
                      <button type="submit" class="login-form-btn" >
                        {{'Password.changePassword' | translate}}
                      </button>
  
                     
                      
                     <button class="login-form-btn"  type="reset"> <i class="ik ik-corner-down-right"></i>   {{'Password.cancel' | translate}}</button>
                    </div>
  
           
                  </form>
  
                </div>
              </div>
            </div>
          </div>
  
  
        </div>
  
  
      </div>
    </div>
  
  </div>